import type { PrefetchContext } from 'src/shared/prefetch';

import type { MergedState } from 'src/app/shared/hooks/state';
import { useMergedStates } from 'src/app/shared/hooks/state';

import { prefetchStartAPetitionPageFcm, useAsyncStartAPetitionPageFcm } from './pageFcm';
import {
	prefetchStartAPetitionPageFcmExperiments,
	useAsyncStartAPetitionPageFcmExperiments,
} from './pageFcmExperiments';

export type StartAPetitionPageCombinedState = MergedState<
	ReturnType<typeof useAsyncStartAPetitionPageFcm>,
	ReturnType<typeof useAsyncStartAPetitionPageFcmExperiments>
>;

export function usePageContext(): StartAPetitionPageCombinedState {
	return useMergedStates(useAsyncStartAPetitionPageFcm(), useAsyncStartAPetitionPageFcmExperiments());
}

export async function prefetchPageContext(context: PrefetchContext): Promise<void> {
	await Promise.all([
		await prefetchStartAPetitionPageFcm(context),
		await prefetchStartAPetitionPageFcmExperiments(context),
	]);
}
